// Universal add-ons system. Each add-on belongs to a category ("branding" or "video")
// and can be optionally tied to specific package IDs (empty list = available for all
// packages in that category). Pricing shown as integers in USD.

export const brandingAddons = [
    { id: "svg", name: "SVG File Export", price: 49, description: "Vector SVG assets for the web" },
    { id: "png", name: "PNG Export Pack", price: 29, description: "Transparent + solid PNGs (multiple sizes)" },
    { id: "jpg", name: "JPG Export Pack", price: 29, description: "High-resolution JPG exports" },
    { id: "ai", name: "AI Source File", price: 99, description: "Editable Adobe Illustrator source" },
    { id: "eps", name: "EPS Source File", price: 79, description: "Print-ready EPS source" },
    { id: "pdf", name: "PDF Brand Export", price: 59, description: "Hi-res brand PDF document" },
    { id: "variation", name: "Additional Logo Variation", price: 149, description: "Extra lockup or alt variant" },
    { id: "social", name: "Extra Social Media Assets", price: 199, description: "5 extra Instagram + Facebook templates" },
    { id: "guidelines", name: "Brand Guidelines PDF", price: 249, description: "Premium 20-page brand guide" },
    { id: "motion", name: "Animated Logo Reveal", price: 349, description: "3-5 second motion logo animation" },
    { id: "priority", name: "Priority Delivery", price: 199, description: "Fast-track turnaround" },
    { id: "revision", name: "Additional Revision Round", price: 79, description: "One extra refinement cycle" },
];

export const formatUSD = (n) => {
    if (n === null || n === undefined) return "";
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
    }).format(n);
};
